module.exports = __webpack_public_path__ + "static/media/background.8e5ff564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/dif/media/background.jpg
// module id = 870
// module chunks = 0